import { NgModule } from '@angular/core';
import { FormsComponent } from './forms.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsRoutingModule } from './forms-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FormService } from './forms.service';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { FileUploadModule } from 'ng2-file-upload';
import { SwiperModule } from 'swiper/angular';

@NgModule({
  imports: [FormsRoutingModule, SharedModule, ReactiveFormsModule, FileUploadModule, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatSelectModule, MatRadioModule, MatStepperModule, SwiperModule],
  declarations: [FormsComponent],
  exports: [FormsComponent],
  providers: [FormService]
})
export class FormsModule { }
